// Corner radius of page-level surfaces: item tables, card tiles and the canvas beside the shortcuts rail.
export const CARD_BORDER_RADIUS = '12px';
